import { client } from './apollo-client'
import {
  getBulkExportMutation,
  getBulkExportFailureMutation,
} from '../graphql/bulkItemExport'

export function getBulkExport(requestData) {
  return client.mutate({
    variables: {
      purpose: requestData.purpose,
      itemTypeId: requestData.itemTypeId,
      itemTypeLabel: requestData.itemTypeLabel,
      bulkType: requestData.bulkType,
      vendorCompleteState: requestData.vendorCompleteState,
    },
    fetchPolicy: 'no-cache',
    mutation: getBulkExportMutation,
  })
}

export function getBulkExportFailure(requestId) {
  return client.mutate({
    variables: {
      requestId: requestId,
    },
    fetchPolicy: 'no-cache',
    mutation: getBulkExportFailureMutation,
  })
}
